import React from 'react';
import { CardSurface } from '@spark';
import '@/features/tasks/styles/task-page-tab-empty.css';

/**
 * Shared empty-state chrome for task page tabs (Evaluations, Versions,
 * Data Editor) — page inset + 1200px white CardSurface (Figma 3001-71663).
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children Empty-state content (illustration, copy, CTA).
 */
export default function TaskPageTabEmpty({ children }) {
    return (
        <div className="task-page-tab-empty">
            <CardSurface
                background="white"
                bordered={false}
                padding="large"
                className="task-page-tab-empty__card"
            >
                <div className="task-page-tab-empty__content">{children}</div>
            </CardSurface>
        </div>
    );
}
